module.exports = __webpack_public_path__ + "static/media/logoweb2dark.a5e4066a.png";